<template>
    <modal :show.sync=show modalClasses="medium-sized-modal call-contact-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Make a Call</h3>

        <base-input
        label="Search"
        v-model="searchQuery"
        v-on:input="debouncedHandler"
        prepend-icon="fas fa-search"
        placeholder="Search...(case-sensitive)"
        >
        </base-input>

        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="tableData"
                style="width: 100%;"
            >
    
                <!-- CALL NAME/ID COLUMN -->
                <el-table-column
                    prop="name"
                    label="Name"
                    class-name="contact-name"
                >
                    <template slot-scope="scope">
                        <div
                            :class="['cursor-pointer', { 'row-selected': isSelected(scope.row) }]"
                            @click="selectRow(scope.row)"
                        >
                            {{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                
                <!-- LEAD ID COLUMN -->
                <el-table-column
                prop="id"
                label="ID"
                >
                    <template slot-scope="scope">
                        <div
                            :class="['cursor-pointer', { 'row-selected': isSelected(scope.row) }]"
                            @click="selectRow(scope.row)"
                        >
                            {{ scope.row.id }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="d-flex justify-content-center mt-4">
            <b-button block variant="primary" class="float-center" @click="callNow" :disabled="selectedRow === null">Call Now</b-button>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { EventBus } from "@/main";
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader,
  debounce
} from '@/assets/js/httpImports.js'

export default {
    name:'create-new-call-modal',
    props:{
        create_new: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        BasePagination,
        clientPaginationMixin,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    computed: {
        show: {
            get() {
                return this.create_new;
            },
            set(newVal) {
                this.$emit('update:create_new', newVal);
            },
        },
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
        EventBus.$on('refresh-status', (res) => {
                this.getnewStatus(res)
        });
    },
    data() {
        return {
            searchQuery:'',
            propsToSearch:['status'],
            modals: {
                update_status: false,
            },
            selectedRow: null,
            searchText: '',
            debouncedHandler: '',
            isTableLoading: false,
            tableData: [
                {
                    id: 1002,
                    name: 'Raphael',
                    telephone_no: '0123456789'
                },
                {
                    id: 1024,
                    name: 'Howard',
                    telephone_no: '0198765432'
                },
            ]
        }
    },
    methods:{
        selectRow(row) {
            if (this.selectedRow === row) {
                this.selectedRow = null;
            } else {
                this.selectedRow = row;
            }
        },
        isSelected(row) {
            return this.selectedRow === row;
        },
        callNow() {
            if (this.selectedRow !== null) {
                console.log(this.selectedRow.telephone_no);
            }
        },
        submit(){
            let form = new FormData()
            form.append('status',this.new_status.status_name)
            form.append('group',this.new_status.status_type)
            axios.post(services.lookup + 'status', form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                    this.$emit('closeModal', false);
                    EventBus.$emit('refresh-status',res)
                    this.resetFormToNull(this.new_status)
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        
    }
}
</script>